<template>
  <div>
    <fetch-error
      v-if="data instanceof FetchError"
      @retry="error = null"
      :error="data"
    ></fetch-error>
    <loader v-else-if="data === null"></loader>
    <template v-else>
      <div>
        <div class="header-section">
          <div
            class="flex md:flex-row w-full flex-col gap-5 md:justify-between sm:items-center"
          >
            <div class="flex flex-1 flex-col gap-2 items-center md:items-start">
              <h2 class="text-2xl font-bold">مدیریت محصولات</h2>
              <h6 class="text-sm sm:text-base">
                دسته‌بندی‌ها، زیردسته‌ها و محصولات خود را مدیریت کنید
              </h6>
            </div>
            <div
              class="flex gap-2 items-end md:justify-end justify-center flex-1 lg:gap-3 w-full"
            >
              <vs-button
                @click="showCreateCategoryPopup = true"
                class="action-btn rounded-lg w-full p-2"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
              >
                دسته بندی
              </vs-button>
              <vs-button
                @click="showCreateSubCategoryPopup = true"
                class="action-btn rounded-lg w-full p-2"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
              >
                زیردسته
              </vs-button>
              <vs-button
                @click="showCreateProductPopup = true"
                class="action-btn rounded-lg w-full p-2"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
              >
                محصول
              </vs-button>
            </div>
          </div>
        </div>
        <div class="flex-1 provider-products">
          <div
            class="bg-white flex flex-1 p-4 mb-6 category-container"
            style="border-radius: 10px; overflow-y: hidden"
          >
            <category
              v-model="activeCategory"
              :categories="data || []"
              @edit="editCategory"
              @remove="deleteCategory"
            >
            </category>
          </div>
          <swiper
            class="swiper"
            @slideChange="slideChange"
            :options="swiperOption"
          >
            <swiper-slide v-for="categoryItem in data" :key="categoryItem.id">
              <div
                v-if="activeCategory && categoryItem.id === activeCategory.id"
                class="products"
              >
                <products
                  :activeCategory="activeCategory"
                  :categories="data || []"
                  @delete="deleteProduct"
                  @productCategoryChanged="productCategoryChanged"
                  @subCategoryDeleted="subCategoryDeleted"
                  @subCategoryChanged="subCategoryChanged"
                ></products>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <vs-popup
        v-if="showCreateProductPopup"
        title="افزودن محصول"
        :active.sync="showCreateProductPopup"
      >
        <product-input
          v-model="productModel"
          :activeCategory="activeCategory"
          :categories="data || []"
          :createMode="true"
          @productAdded="productAdded"
          @close="showCreateProductPopup = false"
        ></product-input>
      </vs-popup>
      <vs-popup
        v-if="showCreateCategoryPopup"
        title="افزودن دسته بندی"
        :active.sync="showCreateCategoryPopup"
      >
        <category-input
          v-model="categoryModel"
          :categories="data || []"
          :createMode="true"
          @close="showCreateCategoryPopup = false"
          @categoryAdded="categoryAdded"
        ></category-input>
      </vs-popup>
      <vs-popup
        v-if="showCreateSubCategoryPopup"
        title="افزودن زیر دسته"
        :active.sync="showCreateSubCategoryPopup"
      >
        <sub-category-input
          v-model="categoryModel"
          :categories="data || []"
          :createMode="true"
          @close="showCreateSubCategoryPopup = false"
          @subCategoryAdded="subCategoryAdded"
          :activeCategory="activeCategory"
        ></sub-category-input>
      </vs-popup>
      <vs-popup
        v-if="showEditCategoryPopup"
        title="ویرایش دسته بندی"
        :active.sync="showEditCategoryPopup"
      >
        <category-input
          v-model="activeCategory"
          :categories="data || []"
          @close="showEditCategoryPopup = false"
          @categoryUpdated="categoryUpdated"
          @delete="onCategoryDeleteFromModal"
        ></category-input>
      </vs-popup>
    </template>
  </div>
</template>
<script>
  import Category from "./../../ProductCategory.vue";
  import Products from "./Products.vue";
  import providerApiService from "../../../services/api/ProviderApiService";
  import productApiService from "../../../services/api/ProductApiService";
  import { mapGetters } from "vuex";
  import FetchError from "../../../services/api/FetchError";
  import ProductInput from "../ProductInput.vue";
  import CategoryInput from "../CategoryInput.vue";
  import SubCategoryInput from "../SubCategoryInput.vue";
  import { isMobileView } from "../../../helpers/Functions";

  export default {
    name: "Input",
    data() {
      return {
        FetchError,
        data: null,
        error: null,
        activeCategory: null,
        showCreateOrderPopup: false,
        user: null,
        showCreateProductPopup: false,
        showCreateCategoryPopup: false,
        showCreateSubCategoryPopup: false,
        showEditCategoryPopup: false,
        productModel: {
          available: true,
          details: { description: "" },
          discount: 0,
          thumbnail: null,
          level: null,
          price: "",
          title: "",
          // english_title: '',
          //unit: null
        },
        categoryModel: {
          thumbnail: null,
          title: "",
          level: 0,
          visible: true,
        },
        swiperOption: {
          allowTouchMove: isMobileView(),
        },
      };
    },
    components: {
      Category,
      Products,
      ProductInput,
      CategoryInput,
      SubCategoryInput,
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),
    },
    watch: {
      activeCategory(item) {
        const categoryIndex = this.data.findIndex(
          (element) => element.id === item.id
        );

        const swiper = this.getSwiperSelector();

        if (swiper) {
          // Now you can use all slider methods like
          swiper.slideTo(categoryIndex, 0, false);
        }
      },
    },
    mounted() {
      this.getMenu();
    },
    methods: {
      getMenu() {
        providerApiService
          .menu(this.currentProvider.id)
          .then((res) => {
            this.data = res.data;
            if (res.data[0]) this.activeCategory = res.data[0];
          })
          .catch((err) => {
            this.data = err;
          });
      },
      deleteProduct(product, subCategory) {
        this.$vs.loading();
        productApiService
          .deleteProduct(this.currentProvider.id, product.id)
          .then(() => {
            this.productDeleted(product, subCategory);

            this.$vs.notify({
              text: "محصول با موفقیت حذف شد",
              color: "success",
              position: "bottom-center",
            });
          })
          .catch((err) => {
            this.$vs.notify({
              text: err.getErrorDescriptions(),
              color: "danger",
              position: "bottom-center",
            });
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      },
      deleteCategory(category) {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "حذف دسته بندی",
          text: `از حذف دسته بندی "${category.title}" اطمینان دارید؟`,
          acceptText: "بلی",
          cancelText: "خیر",
          accept: () => {
            this.doDeleteCategory(category);
          },
        });
      },
      doDeleteCategory(category) {
        this.$vs.loading();
        productApiService
          .deleteCategory(this.currentProvider.id, category.id)
          .then(() => {
            this.categoryDeleted(category);
            this.$vs.notify({
              text: "دسته بندی با موفقیت حذف شد",
              color: "success",
              position: "bottom-center",
            });
          })
          .catch((err) => {
            this.$vs.notify({
              text: err.getErrorDescriptions(),
              color: "danger",
              position: "bottom-center",
            });
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      },
      onCategoryDeleteFromModal() {
        this.showEditCategoryPopup = false;
        this.doDeleteCategory(this.activeCategory);
      },
      editCategory(category) {
        this.activeCategory = category;
        this.showEditCategoryPopup = true;
      },

      // Categories
      categoryAdded(resource) {
        this.activeCategory = resource;
        this.data.push({
          ...resource,
          items: [],
          subCategories: [],
          visible: +resource.visible,
        });
      },
      categoryUpdated(resource) {
        const currentCategoryIndex = this.data.findIndex(
          (element) => element.id === resource.id
        );
        this.activeCategory = {
          ...this.activeCategory,
          items: this.data[currentCategoryIndex].items.map((element) => {
            return {
              ...element,
              available: +resource.available,
            };
          }),
        };
        this.data[currentCategoryIndex].items = this.data[
          currentCategoryIndex
        ].items.map((element) => {
          return {
            ...element,
            available: +resource.available,
          };
        });
        this.data[currentCategoryIndex].title = resource.title;
        this.data[currentCategoryIndex].thumbnail = { ...resource.thumbnail };
        this.data[currentCategoryIndex].level = resource.level;
        this.data[currentCategoryIndex].visible = +resource.visible;
        this.data[currentCategoryIndex].available = +resource.available;
      },
      categoryDeleted(category) {
        this.data.splice(
          this.data.findIndex((item) => item.id === category.id),
          1
        );
      },

      // SubCategories
      subCategoryAdded(resource, category) {
        this.activeCategory = category;
        const categoryIndex = this.data.findIndex(
          (category) => category.id === this.activeCategory.id
        );
        this.data[categoryIndex].subCategories.push({ ...resource, items: [] });
      },
      subCategoryChanged(resource, category, subCategory) {
        const resourceWithItems = {
          ...resource,
          items: subCategory.items,
        };
        this.subCategoryDeleted(subCategory);
        this.subCategoryAdded(resourceWithItems, category);
      },
      subCategoryDeleted(subCategory) {
        let subCategories = [];
        const categoryIndex = this.data.findIndex(
          (d) => d.id === this.activeCategory.id
        );
        subCategories = this.data[categoryIndex].subCategories;
        subCategories.splice(
          subCategories.findIndex((item) => item.id === subCategory.id),
          1
        );
      },

      // Products
      productAdded(resource, category, subCategory) {
        this.activeCategory = category;
        const categoryIndex = this.data.findIndex(
          (category) => category.id === this.activeCategory.id
        );
        let subCategoryIndex = null;
        if (subCategory) {
          subCategoryIndex = this.data[categoryIndex].subCategories.findIndex(
            (element) => element.id === subCategory.id
          );
          this.data[categoryIndex].subCategories[subCategoryIndex].items.push(
            resource
          );
        } else {
          this.data[categoryIndex].items.push(resource);
        }
      },
      productDeleted(product, subCategory) {
        let items = [];
        let subCategoryIndex = null;
        const categoryIndex = this.data.findIndex(
          (d) => d.id === this.activeCategory.id
        );
        if (subCategory) {
          subCategoryIndex = this.data[categoryIndex].subCategories.findIndex(
            (element) => element.id === subCategory.id
          );
          items =
            this.data[categoryIndex].subCategories[subCategoryIndex].items;
        } else {
          items = this.data[categoryIndex].items;
        }
        const index = items.findIndex((element) => element.id === product.id);
        items.splice(index, 1);
      },
      productCategoryChanged(resource, category, subCategory) {
        this.productDeleted(resource, subCategory.current);
        this.productAdded(resource, category, subCategory.target);
      },
      slideChange() {
        const swiper = this.getSwiperSelector();

        if (swiper) {
          // Now you can use all slider methods like
          this.activeCategory = this.data[swiper.activeIndex];
        }
      },
      getSwiperSelector() {
        const swiperHtml = document.querySelector(".swiper");

        if (swiperHtml) {
          return swiperHtml.swiper;
        }

        return null;
      },
    },
  };
</script>

<style scoped lang="scss">
  .header-section {
    width: 100%;
    padding: 15px 0;
    border-radius: 10px;

    @media (min-width: 765px) {
      background-color: white;
      padding: 20px 30px;
      margin-bottom: 30px;
    }
  }

  .category-container {
    height: 139px;
    border: 1px solid gray;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 25px;
  }

  .products {
    display: flex;
    flex-direction: column;
    min-height: 600px;
    width: 100%;
  }

  .action-btn {
    background: linear-gradient(180deg, #141e47 0%, #27387d 100%) !important;
    border: 0.5px solid #fff !important;
    max-width: 120px !important;
    box-shadow: 0px 4px 8px 0px #0000004d;
    border-radius: 12px;

    @media (min-width: 1224px) {
      max-width: 160px !important;
      min-width: 160px !important;
      width: 160px !important;
      height: 48px !important;
      font-size: 16px !important;
    }
  }

  .dropdown {
    z-index: 100;
    border-radius: 10px !important;
    overflow: hidden;
    background-color: #fff;
    position: absolute;
    width: 230px;
    right: 20px !important;

    @media (max-width: 600px) {
      left: 0 !important;
      right: 0 !important;
      margin: 0 auto;
    }
  }
</style>
